"use client"

import { useEffect } from "react"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { RefreshCw, Home, ChevronUp, ChevronDown } from "lucide-react"

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="public-site min-h-screen flex items-center justify-center bg-[#f7f2e8]">
      <div className="text-center px-4 py-16">
        <div className="flex justify-center mb-8">
          <div className="relative">
            <div className="flex items-center justify-center w-24 h-24 rounded-[28px] border border-[#171717]/15 bg-[#eee6db] shadow-[8px_8px_0_#ff6f61]">
              <div className="flex flex-col items-center">
                <ChevronUp className="h-10 w-10 text-[#b83f34] -mb-3" />
                <ChevronDown className="h-10 w-10 text-[#171717] -mt-3" />
              </div>
            </div>
          </div>
        </div>

        <h1 className="text-4xl font-black text-[#171717] mb-4">
          Something went wrong
        </h1>
        <p className="text-[#655d54] mb-8 max-w-md mx-auto">
          An unexpected error occurred. Please try again or return to the home page.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" onClick={reset} className="gap-2">
            <RefreshCw className="h-4 w-4" />
            Try Again
          </Button>
          <Link href="/">
            <Button size="lg" variant="outline" className="gap-2">
              <Home className="h-4 w-4" />
              Go Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
